import { render } from "./Message.vue?vue&type=template&id=37076f52&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=37076f52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37076f52"

export default script